import React, { useState } from "react";
import "./Users.css";
import { Form, Table } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";

const Change_Pin_Password = ({ users, setUserData }) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  console.log("Users data:", users);

  const [success, setSuccess] = useState(false);

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const optionsTwo = [
    { value: "Need Pin", label: "Need Pin" },
    { value: "Need Password", label: "Need Password" },
    { value: "Need Both", label: "Need Both" },
  ];

  return (
    <section className="Manage_My_Points Change_Pin_Password">
      <div className="note_info_div">
        <div className="row me-0 ms-0">
          <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-1 order-1 mb-2"></div>

          <div className="col-xxl-8 col-lg-6 col-md-12 order-lg-2 order-3 mb-2">
            {success && (
              <p className="success_text">
                Reset Pin Password Change Successfully
              </p>
            )}

            <div className="box_holder">
              <div className="table-responsive fixed-height-scroll">
                <Table className="pin_table">
                  <thead>
                    <tr>
                      <th>Sr no.</th>
                      <th>User Name</th>

                      <th>Email</th>
                      <th>Contact No</th>
                      <th>Password</th>
                      <th>Pin</th>
                      <th>Share</th>
                      <th>My Share</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users?.data?.data?.length > 0 ? (
                      users.data.data.map((user, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{user.username}</td>

                          <td>{user.email}</td>
                          <td>{user.contact_no}</td>
                          <td>{user.show_password}</td>
                          <td>{user.show_pin}</td>
                          <td>{user.share} %</td>
                          <td>{user.your_share} %</td>
                          <td>
                            <button
                              className="blue_btn"
                              onClick={() => {
                                setUserData(user);
                                // Handle edit logic here
                              }}
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No users found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>

          <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-3 order-2 mb-2"></div>
        </div>
      </div>
    </section>
  );
};

export default Change_Pin_Password;
